// extracted by mini-css-extract-plugin
export var MailchimpSubscribe = "F_by";
export var aniBgLoading = "F_f";
export var aniSpin = "F_d";
export var input = "F_bz";
export var message = "F_bD";
export var submit = "F_bB";
export var submitBtn = "F_bC";
export var wrap = "F_8";